function copyURI(evt) {
	evt.preventDefault();
	navigator.clipboard.writeText(window.location.href).then(() => {
		// Geri bildirim bildirimi (toast) göster
		const toast = document.createElement('div');
		toast.textContent = 'Bağlantı başarıyla kopyalandı!';
		toast.style.position = 'fixed';
		toast.style.bottom = '20px';
		toast.style.left = '50%';
		toast.style.transform = 'translateX(-50%)';
		toast.style.background = '#000';
		toast.style.color = '#fff';
		toast.style.padding = '10px 20px';
		toast.style.borderRadius = '6px';
		toast.style.fontSize = '14px';
		toast.style.zIndex = '9999';
		toast.style.opacity = '0';
		toast.style.transition = 'opacity 0.3s ease';

		document.body.appendChild(toast);

		// Görünür yap ve sonra kaldır
		setTimeout(() => {
			toast.style.opacity = '1';
		}, 50);

		setTimeout(() => {
			toast.style.opacity = '0';
			setTimeout(() => toast.remove(), 300);
		}, 2000);
	});
}

const copyLinks = document.querySelectorAll('.copy-btn');

for (const copyLink of copyLinks) {
	copyLink.addEventListener('click', copyURI);
}
